module.exports = __webpack_public_path__ + "media/images/flags/16/Gambia-9e9e1e099f6b22cd0a6c75afc34c8a58.png";